module.exports = __webpack_public_path__ + "img/logo.6941c359.svg";